import { render } from "./RadioGroupField.vue?vue&type=template&id=79515112"
import script from "./RadioGroupField.vue?vue&type=script&lang=js"
export * from "./RadioGroupField.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__